import React, { useEffect, useState } from "react";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { NAV_LINKS } from "../mock";

const Logo = () => (
  <a href="#top" className="flex items-center gap-3 shrink-0">
    <span className="grid place-items-center w-11 h-11 rounded-2xl bg-[var(--ink)] text-[var(--olive)] font-serif-display text-2xl font-semibold shadow-sm">
      N
    </span>
    <span className="leading-none">
      <span className="block text-[17px] sm:text-[19px] font-extrabold tracking-tight text-[var(--ink)]">
        NHSSA
      </span>
      <span className="block text-[9px] sm:text-[10px] font-semibold tracking-eyebrow text-[var(--muted)] mt-1">
        NATIONAL HIGH SCHOOL SPORTS ASSN.
      </span>
    </span>
  </a>
);

const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-[var(--cream)]/90 backdrop-blur-md border-b border-[var(--line)]" : "bg-transparent"
      }`}
    >
      <div className="bg-[var(--ink)] text-[var(--cream)] text-center text-[11px] sm:text-[12px] font-semibold tracking-wide py-1.5 px-4">
        PREVIEW — rankings sourced from official polls (United Soccer Coaches, USA Lacrosse, US Squash) &amp; the NHSSA committee
      </div>
      <div className="max-w-[1240px] mx-auto px-5 sm:px-8">
        <div className="h-[76px] flex items-center justify-between gap-4">
          <Logo />

          <nav className="hidden lg:flex items-center gap-9">
            {NAV_LINKS.map((l) => (
              <a
                key={l.label}
                href={l.href}
                className="relative text-[15px] font-semibold text-[var(--ink)] transition-colors hover:text-[var(--olive-2)] after:absolute after:left-0 after:-bottom-1.5 after:h-[2px] after:w-0 after:bg-[var(--olive)] after:transition-all hover:after:w-full"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href="#model"
              className="hidden sm:inline-flex items-center gap-2 rounded-full border border-[var(--line)] bg-[var(--paper)] px-4 py-2.5 text-sm font-semibold text-[var(--ink)] transition-all hover:border-[var(--olive)] hover:shadow-sm"
            >
              The model <ArrowUpRight className="w-4 h-4 text-[var(--olive-2)]" />
            </a>
            <button
              onClick={() => setOpen((v) => !v)}
              className="lg:hidden grid place-items-center w-11 h-11 rounded-xl border border-[var(--line)] bg-[var(--paper)] text-[var(--ink)]"
              aria-label="Menu"
            >
              {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      <div
        className={`lg:hidden overflow-hidden transition-all duration-300 border-t border-[var(--line)] bg-[var(--cream)] ${
          open ? "max-h-96" : "max-h-0"
        }`}
      >
        <nav className="px-6 py-4 flex flex-col">
          {NAV_LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              onClick={() => setOpen(false)}
              className="py-3 text-[17px] font-semibold text-[var(--ink)] border-b border-[var(--line)] last:border-0"
            >
              {l.label}
            </a>
          ))}
        </nav>
      </div>
    </header>
  );
};

export default Header;
